import React from "react";
import { Header, Icon } from "semantic-ui-react";

const TransferenciasCuentasIfisHeader = () => {
  return (
    <>
      <Header as="h2" color="blue">
        <Icon name="building outline" color="yellow" /> Transferencia a otros bancos
      </Header>
    </>
  );
};

export default TransferenciasCuentasIfisHeader;
